import {
  getMeterWatchlist,
  upsertMeterWatchlist,
  patchMeterWatchlist,
  deleteMeterWatchlist,
  getEnergyAlertRules,
  getEnergyAlertEngineRuns,
  postEnergyAlertRules,
  patchEnergyAlertRules,
  deleteEnergyAlertRules
} from '@/api/'

const state = () => ({
  watchlist: []
})

const mutations = {
  SET_WATCHLIST(state, data) {
    state.watchlist = data || []
  }
}

const actions = {
  GET_WATCHLIST({ commit, rootState }) {
    return new Promise((resolve, reject) => {
      getMeterWatchlist({ buildingId: rootState.User.building.BuildingId }, (message) => {
        commit('SET_WATCHLIST', message.data)
        resolve(message.data)
      }, (error) => reject(error))
    })
  },
  UPSERT_WATCHLIST({ dispatch, rootState }, { assetId, enabled, label }) {
    const data = {
      tenantId: rootState.User.tenant.TenantId,
      buildingId: rootState.User.building.BuildingId,
      assetId,
      enabled,
      label
    }
    return new Promise((resolve, reject) => {
      upsertMeterWatchlist(data, () => {
        dispatch('GET_WATCHLIST').then(resolve).catch(reject)
      }, (error) => reject(error))
    })
  },
  PATCH_WATCHLIST({ dispatch, rootState }, { assetId, enabled, label }) {
    const data = {
      tenantId: rootState.User.tenant.TenantId,
      buildingId: rootState.User.building.BuildingId,
      assetId,
      ...(enabled !== undefined ? { enabled } : {}),
      ...(label !== undefined ? { label } : {})
    }
    return new Promise((resolve, reject) => {
      patchMeterWatchlist(data, () => {
        dispatch('GET_WATCHLIST').then(resolve).catch(reject)
      }, (error) => reject(error))
    })
  },
  DELETE_WATCHLIST({ dispatch, rootState }, { assetId }) {
    const data = {
      tenantId: rootState.User.tenant.TenantId,
      buildingId: rootState.User.building.BuildingId,
      assetId
    }
    return new Promise((resolve, reject) => {
      deleteMeterWatchlist(data, () => {
        dispatch('GET_WATCHLIST').then(resolve).catch(reject)
      }, (error) => reject(error))
    })
  },

  GET_RULES({ rootState }, { assetId }) {
    return new Promise((resolve, reject) => {
      getEnergyAlertRules({ buildingId: rootState.User.building.BuildingId, assetId }, (message) => {
        resolve(message.data)
      }, (error) => reject(error))
    })
  },
  CREATE_RULE({ rootState }, data) {
    const payload = {
      ...data,
      tenantId: rootState.User.tenant.TenantId,
      buildingId: rootState.User.building.BuildingId
    }
    return new Promise((resolve, reject) => {
      postEnergyAlertRules(payload, (message) => resolve(message.data), (error) => reject(error))
    })
  },
  UPDATE_RULE({ rootState }, data) {
    const payload = {
      ...data,
      tenantId: rootState.User.tenant.TenantId,
      buildingId: rootState.User.building.BuildingId
    }
    return new Promise((resolve, reject) => {
      patchEnergyAlertRules(payload, (message) => resolve(message.data), (error) => reject(error))
    })
  },
  DELETE_RULE({ rootState }, data) {
    const payload = {
      ...data,
      tenantId: rootState.User.tenant.TenantId,
      buildingId: rootState.User.building.BuildingId
    }
    return new Promise((resolve, reject) => {
      deleteEnergyAlertRules(payload, (message) => resolve(message.data), (error) => reject(error))
    })
  },

  GET_ENGINE_RUNS({ rootState }) {
    return new Promise((resolve, reject) => {
      getEnergyAlertEngineRuns({ buildingId: rootState.User.building.BuildingId }, (message) => {
        resolve(message.data || [])
      }, (error) => reject(error))
    })
  }
}

export default {
  namespaced: true,
  state,
  actions,
  mutations
}

